import { parseTemplate } from 'url-template';
import UserProductGroupErrorResponse from '~/Api/User/ProductGroup/UserProductGroupErrorResponse';
import ApiClient, { ApiClientErrorResponse } from '~/ApiClient';

import mapUserProductGroup from './mapUserProductGroup';
import UserProductGroup from './UserProductGroup';

export interface Result {
	productGroup: UserProductGroup;
}

export default function createUserProductGroup(
	client: ApiClient,
	userId: string,
	name: string | null,
	type: string,
	module: string | null,
	parentId: string | null,
	templateId: string | null
): Promise<Result> {
	const url = parseTemplate('users/{userId}/product-groups');
	const body = {
		name,
		type,
		module,
		parent: parentId !== null ? { id: parentId } : null,
		template: templateId !== null ? { id: templateId } : null,
	};

	return client
		.fetch(url.expand({ userId }), {
			method: 'POST',
			body: JSON.stringify(body),
		})
		.then((response) => response.json())
		.then((response) => ({
			productGroup: mapUserProductGroup(response.productGroup),
		}))
		.catch((response) => ApiClientErrorResponse.wrapError(response, UserProductGroupErrorResponse));
}

export function createUserProductGroupFromVirtualPack(
	client: ApiClient,
	userId: string,
	virtualProductPackId: string,
	name: string | null,
	parentId: string | null
): Promise<Result> {
	const url = parseTemplate('users/{userId}/product-groups/virtual-product-pack-analytics');
	const body = {
		name,
		virtualProductPackId,
		parent: parentId !== null ? { id: parentId } : null,
	};

	return client
		.fetch(url.expand({ userId }), {
			method: 'POST',
			body: JSON.stringify(body),
		})
		.then((response) => response.json())
		.then((response) => ({
			productGroup: mapUserProductGroup(response.productGroup),
		}))
		.catch((response) => ApiClientErrorResponse.wrapError(response, UserProductGroupErrorResponse));
}
